<template>
    <div class="content content-fixed content-auth-alt">
        <div class="container d-flex justify-content-center ht-100p">
            <div class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center">
                <div class="wd-80p wd-sm-300 mg-b-15"><router-link to="/"><img src="../../assets/img/1.png" class="img-fluid" alt=""></router-link></div>
                <h4 class="tx-20 tx-sm-24">Reset your password</h4>
                <p class="tx-color-03 mg-b-30 tx-center">Enter your username or email address. <br> We will send you a link to reset your password.</p>
                <forgot-form></forgot-form>
            </div>
        </div><!-- container -->
    </div><!-- content -->
</template>

<script>
    import ForgotForm from "../../components/form/ForgotForm";
    export default {
        name: "Forgot",
        components:{
            ForgotForm
        }
    }
</script>

<style scoped>

</style>